export default "__VITE_ASSET__Dh9nbMDr__"